import urlJoin from 'url-join';
import { getEnv } from 'services/env-service';

const DEV_BASE_URL = getEnv('REACT_APP_DEV_BASE_URL');
const LIVE_BASE_URL = getEnv('REACT_APP_LIVE_BASE_URL');
export const UNSUBSCRIPTION_BASE_URL = getEnv(
  'REACT_APP_UNSUBSCRIPTION_BASE_URL',
);
export const isDevelopment = getEnv('REACT_APP_ENV') === 'development';

export const BASE_URL = isDevelopment ? DEV_BASE_URL : LIVE_BASE_URL;
export const MAILER_MICROSERVICE_BASE_URL = getEnv(
  'REACT_APP_MAILER_MICROSERVICE_BASE_URL',
);

export const CSV_UTILITIES_BASE_URL = getEnv(
  'REACT_APP_CSV_UTILITIES_BASE_URL',
);

export const ACG_BASE_URL = getEnv('REACT_APP_ACG_BASE_URL');

export const GET = 'get';
export const POST = 'post';
export const PUT = 'put';
export const DELETE = 'delete';
export const PATCH = 'patch';
export const HTTP_METHODS = { GET, POST, PUT, DELETE, PATCH };

export const emailRoutes = {
  UNSUBSCRIBE: 'unsubscribe/',
  LISTING_UNSUBSCRIPTION: 'unsubscribe/list',
  COUNT_UNSUBSCRIPTION: 'unsubscribe/count',
  BULK_UNSUBSCRIBE: 'unsubscribe/bulk-unsubscribe',
  VALIDATE_BULK_UNSUBSCRIBE: 'unsubscribe/bulk-unsubscribe/validate',
  RE_SUBSCRIBE: 'unsubscribe/re-subscribe',
  UNSUBSCRIBE_MANUAL: 'unsubscribe/unsubscribe-manual',
  RE_SUBSCRIBE_MANUAL: 'unsubscribe/resubscribe-manual',
  UNSUBSCRIBE_ORGANIZATION: 'unsubscribe/unsubscribe-organization',
  UNSUBSCRIBE_ORGANIZATION_EMAIL_COUNT:
    'unsubscribe/unsubscribe-organization/emailCount',
  RE_SUBSCRIBE_ORGANIZATION: 'unsubscribe/resubscribe-organization',
  UNSUBSCRIBED_DOMAINS: 'unsubscribe/unsubscribed-domains',
  UNSUBSCRIBED_EMAILS: 'unsubscribe/search-by-email?email=',
  CHANGE_PAUSE_DURATION: 'unsubscribe/change-pause-duration',
  CHANGE_UNSUBSCRIBE_EMAIL_TYPE_PREFERENCES: 'unsubscribe/change-email-type',
  PAUSE_REASON: 'unsubscribe/pause-reason',
  SEND_SAVED_TEMPLATE: 'mail/send-saved-template',
  SEND_CSV_MAIL: 'mail/send-csv-mail',
  SEND_MULTI_TEMPLATE: 'mail/send-multi-template',
  SCHEDULE_MAIL_SAVED_TEMPLATE: 'mail/schedule-mail-saved-template',
  RECOMMENDATIONS: 'recommendations',
  RECOMMENDATIONS_JD: 'recommendations/save-jd',
  EMAIL_TYPES: 'mail/email-types',
  VALIDATE_CSV: 'mail/validate-csv',
  SPLIT_MICROSOFT_CSV: 'mail/utils/split-microsoft-csv',
  REMOVE_INVALID_EMAIL_CSV: 'mail/utils/remove-invalid-email-csv',
  SIMULATE_THROTTLE_CSV: 'mail/utils/simulate-throttle-csv',
  SAVE_MX_RECORD_CSV: 'mail/utils/save-mx-record-csv',
  GET_ALL_EMAIL_TYPES: 'mail/email-types/list',
  CONFIGURE_EMAIL_TYPES: 'mail/email-types/configure',
  DELETE_EMAIL_TYPES: id => `mail/email-types/delete/${id}`,
  STOP_CSV_MAIL: id => `mail/stop-csv-mail/${id}`,
  PAUSE_CSV_MAIL: id => `mail/pause-csv-mail/${id}`,
  TRIGGER_CSV_MAIL: id => `mail/trigger-csv-mail/${id}`,
  RESUME_CSV_MAIL: id => `mail/resume-csv-mail/${id}`,
  GET_CSV_SIGNED_URL: id => `mail/csv/signed-url/${id}`,
  WATCH_CSV_MAIL: id => `mail/watch-csv-mail/${id}`,
  UNWATCH_CSV_MAIL: id => `mail/unwatch-csv-mail/${id}`,
  GET_CSV_WATCH_STATUS: id => `mail/csv-watch-status/${id}`,
  GET_ONE_CSV_SUMMARY: id => `mail/csv-summary/${id}`,
  GET_EMAIL_SENDING_HISTORY: `mail/history/list`,
  GET_EMAIL_DETAILS_BY_ID: id => `mail/history/details/${id}`,
  GET_TEMPLATE_METRICS_BY_ID_AND_DATE_RANGE: id => `mail/${id}/summary`,
  GET_CLICK_EMAILS_BY_ID_AND_DATE_RANGE: id => `mail/${id}/click-emails`,
  GET_THROTTLE_EXEMPTION_LIST: 'throttler/exemptions',
  ADD_TO_THROTTLE_EXEMPTIONS: 'throttler/exemptions',
  DELETE_BULK_THROTTLE_EXEMPTIONS: 'throttler/exemptions/bulk-delete',
  ADD_TO_THROTTLE_EXEMPTIONS_CSV: 'mail/utils/throttle-exemption-csv',
  GET_EMAIL_QUEUE_WATCHERS: `mail/email-queue/watchers`,
  WATCH_EMAIL_QUEUE: `mail/email-queue/watch`,
  UNWATCH_EMAIL_QUEUE: `mail/email-queue/unwatch`,
  ADD_EMAIL_QUEUE_WATCHER: `mail/email-queue/add-watcher`,
  REMOVE_EMAIL_QUEUE_WATCHER: `mail/email-queue/remove-watcher`,
};

export const projectRoutes = {
  GET_PROJECTS: 'project/',
  ADD_PROJECT: 'project/',
  EDIT_PROJECT: 'project/',
  DELETE_PROJECT: 'project/',
};

export const categoryRoutes = {
  GET_CATEGORIES: 'category/',
  ADD_CATEGORY: 'category/',
  EDIT_CATEGORY: 'category/',
  DELETE_CATEGORY: 'category/',
};

export const apiKeysRoutes = {
  GET_API_KEYS: 'admin/get-api-keys',
  CREATE_API_KEY: 'admin/create-api-key',
  DELETE_API_KEY: 'admin/delete-api-key/',
};

export const templateRoutes = {
  GET_TEMPLATES: 'mail/',
  GET_TEMPLATE_BY_ID: id => `mail/${id}`,
  GET_TEMPLATE_EDIT_HISTORY: id => `mail/${id}/edit-history`,
  COUNT_TEMPLATES: 'mail/templates/count',
  GET_TEMPLATES_IN_CATEGORY: 'mail/in-category/',
  ADD_TEMPLATE: 'mail/',
  EDIT_TEMPLATE: 'mail/',
  DELETE_TEMPLATE: 'mail/',
  REACTIVATE_TEMPLATE: id => `mail/${id}/reactivate`,
  VALIDATE_HTML_TEMPLATE: 'mail/validate-template-html/',
  VALIDATE_HTML_TEMPLATE_V2: 'mail/validate-html/',
  GENERATE_TEMPLATE_REPORT: 'mail/template-report/generate',
  TEMPLATE_REPORT_STATUS: 'mail/template-report/status',
  GENERAL_TEMPLATE_REPORT: 'mail/template-report/general',
  TOP_UNOPTIMIZED_TEMPLATES: 'mail/template-report/top-unoptimized-templates',
  TOP_UNOPTIMIZED_CATEGORIES: 'mail/template-report/top-unoptimized-categories',
  SET_TEMPLATE_QUOTA: (templateId, quota) =>
    `mail/quota/${templateId}/${quota}`,
};

export const webhookRoutes = {
  GET_ALL_WEBHOOKS: 'webhook/',
  GET_WEBHOOKS: 'webhook/by-template/',
  ADD_WEBHOOK: 'webhook/',
  DELETE_WEBHOOK: 'webhook/',
};

export const authRoutes = {
  LOGIN: 'admin/login',
  CONFIRM: 'admin/confirm',
  GOOGLE_LOGIN: 'auth/google-login',
};

export const perfRoutes = {
  SAVED_SUMMARY: 'metrics/summary',
  SUMMARY: 'metrics/template-summary',
  SERVICES_BY_TEMPLATE: 'metrics/detail-by-template',
  LINKS_BY_TEMPLATE: 'metrics/link-click-by-template',
  RECIPIENT: 'metrics/recipient',
  DELIVERY_RATE: 'metrics/total-delivery-rate',
  COUNT_UPLOADED_CSV: 'metrics/count-uploaded-csv',
  GET_UPLOADED_CSV: 'metrics/get-uploaded-csv',
  GET_CSV_METRICS: 'metrics/csv-metrics',
};

export const AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR';

export const gmailRoutes = {
  AUTHORIZE: 'authorized-account/authorize-account',
  AUTHORIZE_SUCCESS: 'authorized-account/authorize-account-success',
  GET_AUTHORIZED_ACCOUNTS: 'mail/all-authorized-sending-gmail-accounts',
  GET_CAMPAIGN_HISTORY: 'metrics/gmail-campaign-history',
  GET_ACTIVE_CAMPAIGNS_SUMMARY: 'metrics/gmail-active-campaigns-summary',
  GET_GMAIL_ACCOUNT_METRICS: id => `metrics/gmail-account-metrics/${id}`,
  GET_GMAIL_ACCOUNT_WATCH_STATUS: `mail/gmail/watch-status`,
  WATCH_GMAIL_ACCOUNTS: `mail/gmail/watch-accounts`,
  UNWATCH_GMAIL_ACCOUNTS: `mail/gmail/unwatch-accounts`,
  GET_GMAIL_DAILY_LIMIT: `${MAILER_MICROSERVICE_BASE_URL}authorized-account/limit`,
};

export const adminRoutes = {
  CREATE_USER: 'admin/create-user',
  GET_USERS: 'admin/get-users',
  GET_USER: id => `admin/get-user/${id}`,
  GET_TOTAL_USERS: 'admin/total-users',
  UPDATE_USER: 'admin/update-user',
  UPDATE_USER_ROLE: 'admin/update-user-role',
  RESET_USER_PASSWORD: 'admin/reset-password',
  DELETE_USER: 'admin/delete-user/',
  LIST_DEDICATED_IP: 'admin/dedicated-ip',
  CREATE_DEDICATED_IP: 'admin/dedicated-ip/create',
  SYNC_DEDICATED_IP: 'admin/dedicated-ip/sync',
  DELETE_DEDICATED_IP: 'admin/dedicated-ip/',
  LIST_DOMAIN_MONITORING: 'admin/domain-monitoring',
  CREATE_DOMAIN_MONITORING: 'admin/domain-monitoring/create',
  DELETE_DOMAIN_MONITORING: 'admin/domain-monitoring/',
  SUBMIT_BUG_FEATURE: 'admin/bug-feature',
  UPDATE_BUG_FEATURE_STATUS: id => `admin/bug-feature/status/${id}`,
  LIST_BUG_FEATURE: 'admin/bug-feature',
  GET_ONE_BUG_FEATURE: id => `admin/bug-feature/${id}`,
  GET_BUG_FEATURE_STATISTICS: 'admin/bug-feature/statistics',
  GET_BUG_FEATURE_ATTACHMENT_URL: id =>
    `admin/bug-feature/attachment-url/${id}`,
  GET_AUTHORIZED_DOMAINS: 'admin/authorized-domains',
  ADD_AUTHORIZED_DOMAIN: 'admin/authorized-domains',
  UPDATE_AUTHORIZED_DOMAIN: id => `admin/authorized-domains/${id}`,
  GET_SIB_DOMAINS: 'admin/sib-domains',
  ADD_SIB_DOMAIN: 'admin/sib-domains',
  UPDATE_SIB_DOMAIN: id => `admin/sib-domains/${id}`,
  DELETE_SIB_DOMAIN: id => `admin/sib-domains/${id}`,
};

export const userRoutes = {
  CHANGE_USER_PASSWORD: 'user/change-user-password',
  GET_SIGNED_IN_USER: 'user/me',
  GET_PERMISSIONS_BY_USER: 'user/permissions/user',
  GET_PERMISSIONS_BY_ROLE: 'user/permissions',
  GET_ALL_PERMISSIONS: 'user/permissions',
  GET_SIGNED_IN_USER_V2: 'auth/current-profile',
};

export const experimentationRoutes = {
  GET_FEATURES: 'experimentation/get-features',
  SEND_EMAILS: 'experimentation/send-emails',
  VALIDATE_CSV: 'experimentation/validate-csv',
  GET_FLAGS: 'experimentation/get-flags',
  GET_ALL_FEATURES: 'experimentation/get-all-features',
};
export const enochRoutes = {
  GET_GENERAL_REPORT: 'enoch/report/general',
  GET_HISTOGRAM_REPORT: 'enoch/report/histogram',
  GET_ALL_MACHINE_IPS: 'enoch/report/machine-ips',
  GET_ALL_EMAILS: 'enoch/report/emails',
  GET_ENOCH_REPORT_HISTORY: 'enoch/report/history',
  GET_ENOCH_REPORT_HISTORY_BY_VM: 'enoch/report/history_by_vm',
  GET_ENOCH_REPORT_LOGS_HISTORY: 'enoch/report/:reportId/logs',
  GET_ENOCH_PROFILE_CONNECTION_STATS: 'enoch/profile/connection-stats',
  GET_ENOCH_PROFILE_DETAILS: 'enoch/profile/details',
  GET_ENOCH_CONFIG: ip => `enoch/config/${ip}?actual=true&version=2`,
  SAVE_ENOCH_CONFIG: ip => `enoch/config/${ip}`,
  GET_PROFILES_OF_VM: ip => `enoch/profile/vm/${ip}`,
  TERMINATE_ENOCH_JOB: ip => `enoch/broadcast/${ip}/terminate`,
  RUN_ENOCH_JOB: ip => `enoch/broadcast/${ip}/run`,
  GET_IDLE_ENOCH_VMS: 'enoch/config/list/idle',
  GET_RUNNING_ENOCH_VMS: 'enoch/config/list/running',
};

export const qaInternalRoutes = {
  PURGE_REDIS_CACHE: 'qa-internal/clean-redis-cache',
};

export const miscRoutes = {
  GET_ALL_HOME_PAGE_LINK_GROUPS: 'misc/home/groups',
  SET_HOME_PAGE_LINK_GROUPS: 'misc/home/groups',
  SET_HOME_PAGE_LINKS: groupId => `misc/home/${groupId}/links`,
};

export const csvUtilitiesRoutes = {
  VALIDATE_CSV: `${CSV_UTILITIES_BASE_URL}self-serve-magic-link/validate`,
  CONVERT_CSV: `${CSV_UTILITIES_BASE_URL}self-serve-magic-link/convert`,
  LIST_CSV: `${CSV_UTILITIES_BASE_URL}self-serve-magic-link`,
  DOWNLOAD_ORIGINAL: id =>
    `${CSV_UTILITIES_BASE_URL}self-serve-magic-link/download/original/${id}`,
  DOWNLOAD_RESULT: id =>
    `${CSV_UTILITIES_BASE_URL}self-serve-magic-link/download/result/${id}`,
};

export const domainWarmupRoutes = {
  GET_ALL_DOMAINS: `${MAILER_MICROSERVICE_BASE_URL}domain`,
  REGISTER_NEW_DOMAIN: `${MAILER_MICROSERVICE_BASE_URL}domain/register`,
  UPDATE_DOMAIN: (domain: string) =>
    `${MAILER_MICROSERVICE_BASE_URL}domain/${domain}`,
  DELETE_DOMAIN: (domain: string) =>
    `${MAILER_MICROSERVICE_BASE_URL}domain/${domain}`,
  CHANGE_DAILY_LIMIT: `${MAILER_MICROSERVICE_BASE_URL}domain/change-daily-limit`,
  CHANGE_DISTRIBUTION: `${MAILER_MICROSERVICE_BASE_URL}domain/change-distribution`,
};

export const domainRoutes = {
  GET_ALL_IP_POOL_MAPPINGS: 'domain/receiver-provider',
  SET_IP_POOL_MAPPING: 'domain/receiver-provider/set-ip-pool',
};

export const unsubscribeRoutes = {
  GET_UNSUBSCRIPTION_STATUS: token =>
    urlJoin(UNSUBSCRIPTION_BASE_URL, `unsubscribe/status/${token}`),
  UNSUBSCRIBE: urlJoin(UNSUBSCRIPTION_BASE_URL, `unsubscribe`),
  RE_SUBSCRIBE: urlJoin(UNSUBSCRIPTION_BASE_URL, `unsubscribe/re-subscribe`),
  PAUSE_EMAILS: urlJoin(UNSUBSCRIPTION_BASE_URL, `unsubscribe/pause-emails`),
  CHANGE_PAUSE_DURATION: urlJoin(
    UNSUBSCRIPTION_BASE_URL,
    `unsubscribe/change-pause-duration`,
  ),
  CHANGE_UNSUBSCRIBE_EMAIL_TYPE_PREFERENCES: urlJoin(
    UNSUBSCRIPTION_BASE_URL,
    `unsubscribe/change-email-type`,
  ),
  CHANGE_PAUSE_REASON: urlJoin(
    UNSUBSCRIPTION_BASE_URL,
    `unsubscribe/pause-reason`,
  ),
};

export const spamWordsRoutes = {
  GET_ALL_SPAM_WORDS: urlJoin(BASE_URL, `spam-word`),
  CREATE_SPAM_WORD: urlJoin(BASE_URL, `spam-word`),
  DELETE_SPAM_WORD: (word: string) => urlJoin(BASE_URL, `spam-word/${word}`),
};

export const acgRoutes = {
  phase1: {
    GET_SIGNED_URL: urlJoin(ACG_BASE_URL, `phase-1/storage/signed-url`),
    BQ_ROUTINES_SYNC_STATUS: urlJoin(
      ACG_BASE_URL,
      `phase-1/bigquery-default-values/routines/sync-status`,
    ),
    SYNC_BQ_ROUTINES: urlJoin(
      ACG_BASE_URL,
      `phase-1/bigquery-default-values/routines/sync`,
    ),
    LIST_BQ_ROUTINES: urlJoin(
      ACG_BASE_URL,
      `phase-1/bigquery-default-values/routines`,
    ),
    LIST_ROUTINES_ARGUMENTS: routineId =>
      urlJoin(
        ACG_BASE_URL,
        `phase-1/bigquery-default-values/routines/${routineId}/arguments`,
      ),
    UPDATE_ROUTINE_DEFAULT_VALUE: routineId =>
      urlJoin(
        ACG_BASE_URL,
        `phase-1/bigquery-default-values/routines/${routineId}/set-default-values`,
      ),
    LIST_CAMPAIGN_GENERATION_JOBS: urlJoin(
      ACG_BASE_URL,
      `phase-1/campaign-generation`,
    ),
    GET_CAMPAIGN_GENERATION_JOB: jobId =>
      urlJoin(ACG_BASE_URL, `phase-1/campaign-generation/${jobId}`),
    GENERATE_CAMPAIGN: urlJoin(
      ACG_BASE_URL,
      `phase-1/campaign-generation/generate`,
    ),
    CREATE_UPLOAD_URLS: urlJoin(
      ACG_BASE_URL,
      `phase-1/email-exclusion/create-upload-urls`,
    ),
    CREATE_EMAIL_EXCLUSION_JOB: urlJoin(
      ACG_BASE_URL,
      `phase-1/email-exclusion/create-job`,
    ),
    GET_EMAIL_EXCLUSION_JOBS: urlJoin(
      ACG_BASE_URL,
      `phase-1/email-exclusion/jobs`,
    ),
    GET_EMAIL_EXCLUSION_JOB: jobId =>
      urlJoin(ACG_BASE_URL, `phase-1/email-exclusion/jobs/${jobId}`),
  },
};
